<script setup lang="ts">
import { useFormValidation } from "../../../../composables/useFormValidation";
import { required } from "../../../../utils/validation";
import TextInput from "../../../../components/ui/form/TextInput.vue";
import CheckInput from "../../../../components/ui/form/CheckInput.vue";
import { api } from "../../../../api/Api";
import Toast from "../../../../services/Toast";
import { Permission } from "../../../../types/auth";
import { ref, onMounted } from "vue";
import ModalFormTemplate from "../../../../components/ui/Templates/ModalFormTemplate.vue";
import AmountInput from "../../../../components/ui/form/AmountInput.vue";

const props = defineProps<{
  data?: any | null;
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
  title: string | null;
  endPoint: string;
  permissions?: Permission[];
  listCreateName?: string;
}>();

const emit = defineEmits<{
  (e: "save", data: any): void;
  (e: "close"): void;
}>();

const {
  fields,
  formData,
  setFieldRules,
  validateForm,
  resetForm,
  setFormData,
} = useFormValidation({
  code: props.data?.code || "",
  name: props.data?.name || props.listCreateName || "",
  credit_days: props.data?.credit_days || 0,
  active: props.data?.active || true,
  uid: props.data?.uid || "",
});

setFieldRules("code", [required("Code is required")]);
setFieldRules("name", [required("Name is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != "" ? "update" : "create";
    const response = await api.post(
      (props.endPoint.slice(-1) == "/"
        ? props.endPoint
        : props.endPoint + "/") + action,
      formData.value
    );
    if (response.success == true) {
      Toast.show("saved successfully");
      emit("save", response.data);
      if (close) {
        emit("close");
      } else if (newRecord) {
        resetForm();
      } else {
        setFormData(response.data);
      }
    }
  }
};

const handleGetRecord = async () => {
  const response = await api.post(
      (props.endPoint.slice(-1) == "/"
        ? props.endPoint
        : props.endPoint + "/") + "record",
    {
      id: props.data?.uid,
    }
    );
    if (response.success == true) {
      console.log(response.data);
    }
};

const isReadOnly = ref(true);
onMounted(() => {
  console.log(props.data);
  isReadOnly.value = props.mode == 'view'
  handleGetRecord()
})

</script>
<template>
  <ModalFormTemplate
    :data="data"
    :mode="mode"
    :title="title"
    :endPoint="endPoint"
    :perm="permissions"
    :listCreateName="listCreateName"
    :tabList="[]"
    :formData="formData"
    @save="handleSubmit"
    @close="$emit('close')"
  >
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.code.value"
          label="Code"
          placeholder="Enter Code"
          :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null"
          @blur="fields.code.touched = true"
        />

        <TextInput
          v-model="fields.name.value"
          label="Name"
          placeholder="Enter Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />

        <AmountInput
          v-model="fields.credit_days.value"
          label="Credit Days"
          :readonly="isReadOnly"
          :error="fields.credit_days.touched ? fields.credit_days.error : null"
          @blur="fields.credit_days.touched = true"
        />

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>
